<template>
  <v-flex
    :xs6="paymentList.length > 1"
    :xs12="paymentList.length == 1"
    class="px-1"
  >
    <h3 v-if="paymentList.length == 1" class="text-xs-center">
      <slot></slot>
    </h3>
    <v-btn
      v-else
      :color="theme.color"
      block
      :dark="!disabled"
      :disabled="disabled"
      small
      @click="$emit('handleClick')"
      :outline="transferType != type"
    >
      <slot></slot>
    </v-btn>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    paymentList: {},
    transferType: {},
    type: {},
    disabled: false
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  }
}
</script>

<style lang="scss" scoped></style>
